import React from 'react';

function Logo(props) {
  return (
    <img
      alt="Logo"
      src="/images/precisa_logo.png"
      width="120"        
      height="auto"      
      {...props}          
    />
  );
}

export default Logo;
